/**
 * Hinweise in deutsche Sätze.
 *
 * Der Server liefert nur `kind`, das Feature und den Auslöser — der Text entsteht
 * hier. Deshalb heißt ein umbenanntes Feature auch in alten Hinweisen richtig, und
 * eine bessere Formulierung gilt rückwirkend für alle statt nur für die nächsten.
 */

import type { NotificationDto, NotificationKind } from '@pmpro/shared';

/**
 * Was jemand getan hat — als Fortsetzung des Namens: „Anna Beck **hat
 * kommentiert**".
 *
 * Bewusst ohne den Feature-Titel: Der steht in der Zeile darunter und muss nicht
 * zweimal gelesen werden.
 */
const VORGANG: Record<NotificationKind, string> = {
  comment: 'hat kommentiert',
  status: 'hat den Status geändert',
  assigned: 'hat dir dieses Feature zugewiesen',
  task: 'hat dir eine Aufgabe zugewiesen'
};

export function hinweisVorgang(hinweis: NotificationDto): string {
  return VORGANG[hinweis.kind];
}

/**
 * Wer gehandelt hat. Ein gelöschtes Konto wird benannt, nicht verschwiegen — sonst
 * steht da ein Satz ohne Subjekt, und man rätselt statt zu lesen.
 */
export function hinweisUrheber(hinweis: NotificationDto): string {
  return hinweis.actor?.name ?? 'Gelöschtes Konto';
}
